import { calmTokens as t } from '../../shared/tokens';
import { MONTHS_INITIALS } from '../../shared/locale';
import {
  templateId,
  RECURRENCE_KINDS,
  getRecurrenceKind,
  getActiveMonths,
} from '../../shared/recurrence';

function TplPill({ tpl }) {
  const kindKey = getRecurrenceKind(tpl.recurrencePattern);
  const kind = RECURRENCE_KINDS[kindKey];
  const isMonthly = kindKey === 'monthly';
  const activeMonths = isMonthly ? null : getActiveMonths(tpl.recurrencePattern);
  const isDebit = tpl.type === 'debit';
  const amount = Number(tpl.amount) || 0;
  const faded = tpl.isActive === false;

  return (
    <div
      style={{
        background: kind.bg,
        border: `1px solid ${kind.border}`,
        borderLeft: `3px solid ${kind.color}`,
        borderRadius: 6,
        padding: '4px 6px 5px',
        opacity: faded ? 0.45 : 1,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          minWidth: 0,
        }}
      >
        <span
          style={{
            fontSize: 10.5,
            color: t.text,
            fontWeight: 500,
            letterSpacing: -0.1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            minWidth: 0,
          }}
          title={tpl.title}
        >
          {tpl.title}
        </span>
        <span
          style={{
            fontSize: 9.5,
            fontFamily: t.fontMono,
            color: isDebit ? t.debit : t.credit,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums',
            letterSpacing: -0.1,
          }}
        >
          {isDebit ? '−' : '+'}
          {Math.round(amount)}€
        </span>
      </div>

      {!isMonthly && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            marginTop: 3,
            gap: 1,
          }}
          aria-label={`Mois actifs : ${activeMonths
            .map((m) => MONTHS_INITIALS[m])
            .join(' ')}`}
        >
          {MONTHS_INITIALS.map((m, i) => {
            const on = activeMonths.includes(i);
            return (
              <span
                key={i}
                style={{
                  fontSize: 7.5,
                  lineHeight: 1,
                  textAlign: 'center',
                  color: on ? kind.color : t.textMute,
                  opacity: on ? 1 : 0.3,
                  fontFamily: t.fontMono,
                  fontWeight: on ? 600 : 400,
                  letterSpacing: 0,
                }}
              >
                {m}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function SettingsCalendarCell({ day, tpls = [], onSelect, active = false }) {
  const hasTxs = tpls.length > 0;

  const borderColor = active
    ? t.accent
    : hasTxs
      ? t.borderS
      : t.border;

  return (
    <button
      type="button"
      onClick={hasTxs ? () => onSelect?.(day) : undefined}
      disabled={!hasTxs}
      aria-label={
        hasTxs
          ? `Jour ${day}, ${tpls.length} récurrente${tpls.length > 1 ? 's' : ''}`
          : `Jour ${day}, aucune récurrente`
      }
      style={{
        height: 148,
        background: hasTxs ? 'rgba(255,255,255,0.015)' : t.surface,
        border: `1px solid ${borderColor}`,
        borderRadius: 12,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        cursor: hasTxs ? 'pointer' : 'default',
        position: 'relative',
        color: t.text,
        fontFamily: t.fontUi,
        textAlign: 'left',
        transition: 'all .15s',
        outline: 'none',
        boxShadow: active ? `0 0 0 1px ${t.accent}` : 'none',
        overflow: 'hidden',
      }}
      onMouseEnter={(e) => {
        if (!hasTxs || active) return;
        e.currentTarget.style.background = 'rgba(255,255,255,0.035)';
      }}
      onMouseLeave={(e) => {
        if (!hasTxs || active) return;
        e.currentTarget.style.background = 'rgba(255,255,255,0.015)';
      }}
    >
      <div
        style={{
          padding: '8px 10px 4px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontFamily: t.fontMono,
            fontSize: 11,
            color: hasTxs ? t.text : t.textMute,
            fontWeight: hasTxs ? 500 : 400,
            letterSpacing: -0.2,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {String(day).padStart(2, '0')}
        </span>
        {hasTxs && tpls.length > 1 && (
          <span
            style={{
              fontSize: 9,
              color: t.textMute,
              fontFamily: t.fontMono,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {tpls.length}
          </span>
        )}
      </div>

      <div
        className="settings-cell-scroll"
        style={{
          padding: '0 7px 8px',
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
        }}
      >
        {tpls.map((tpl) => (
          <TplPill key={templateId(tpl)} tpl={tpl} />
        ))}
      </div>
    </button>
  );
}
